import React from 'react'
import Datepicker from './DatePicker/Datepicker'
import { formatDateToMMDDYYYY } from '../../utils/date'
import ValidationErrorDisplay from './FormFields/ValidationErrorDisplay'

interface Props {
  name: string
  label?: string
  value?: string
  onChange?: (v: string) => void
  required?: boolean
  className?: string
  disableFutureDates?: boolean
  /** Inline field-level error message (e.g. 'Required'). */
  error?: string
}

/**
 * Small wrapper for an admin-only Datepicker used in multiple admin screens.
 * Constrains width and provides sensible defaults for iconView usage.
 */
const ManualRequestedDate: React.FC<Props> = ({
  name,
  label,
  value,
  onChange,
  required,
  className,
  disableFutureDates,
  error,
}) => {
  const normalizedValue = formatDateToMMDDYYYY(value || '')

  const handleChange = (_fieldName: string, val: string | string[]) => {
    if (onChange) {
      onChange(Array.isArray(val) ? val[0] : val)
    }
  }

  return (
    <div className={className || 'w-auto max-w-xs'}>
      <Datepicker
        name={name}
        label={label}
        value={normalizedValue}
        onChange={handleChange}
        openBehaviour="iconView"
        calendarWidth={300}
        calendarHeight={360}
        required={required}
        helperText="MM/DD/YYYY"
        disableFutureDates={disableFutureDates}
      />
      {error && (
        <div className="mt-1">
          <ValidationErrorDisplay message={error} />
        </div>
      )}
    </div>
  )
}

export default ManualRequestedDate